import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Form, Button } from "react-bootstrap";
//import { createDevice } from "../services/createDevice";
import Box from "@mui/material/Box";
import Editable from "react-bootstrap-editable";
import axios from "axios";
import Select from "react-select";
import { environment } from "../../environment";
// import Dropdown from "./Dropdown";
import CustomListDropDown from "../Components/CustomListDropDown";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Country, State, City } from "country-state-city";
import Multiselect from "multiselect-react-dropdown";
import { Redirect } from "react-router-dom";
import {
  CountryDropdown,
  RegionDropdown,
  CountryRegionData,
} from "react-country-region-selector";
// import { useEffect } from "react";
import Container, { TableContainer, TextField } from "@mui/material";
import NavbarNew from "../Components/NavbarNew";

const MySwal = withReactContent(Swal);

const AddDeviceSysAdmin = ({ history }) => {
  const [dap_deviceList, setDapDevices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [dap_category, setCategory] = useState([]);
  const [device_access_token, setAccessToken] = useState("");
  const [device_label, setLabel] = useState("");
  const [device_version, setVersion] = useState("");
  const [box_categories, setboxcategories] = useState([]);
  const [display_suggestion, setDisplaySuggestion] = useState([
    {
      display: "none",
      zIndex: "-999",
    },
  ]);
  const [product_categories, setproductcategories] = useState([]);
  const [product_suggestion, setProductSuggestion] = useState([
    {
      display: "none",
      zIndex: "-999",
    },
  ]);
  const [duplicate, setDuplicate] = useState(false);
  // const [box_type,setBoxType] = useState()
  const [displayBoxType, setDisplayBoxType] = useState([
    {
      display: "none",
    },
  ]);

  const [inputfields, setInputFields] = useState([
    {
      deviceName: "",
      deviceLabel: "",
      deviceVersion: "",
      deviceCategory: "",
      accessToken: "",
      deviceType: "",
      deviceTypeId: "",
      boxType: "",
      isbox: false,
      inventoryUserId: JSON.parse(localStorage.getItem("user"))._id,
      // isInstalled: false,
      // shipmentIdMongo: "",
    },
  ]);

  useEffect(() => {
    const dispProductSuggestion = [...product_suggestion];
    dispProductSuggestion[0] = { display: "none", zIndex: "-999" };
    setDisplaySuggestion(dispProductSuggestion);

    const dispSuggestion = [...display_suggestion];
    dispSuggestion[0] = { display: "none", zIndex: "-999" };
    setDisplaySuggestion(dispSuggestion);

    const dispBoxType = [...displayBoxType];
    dispBoxType[0] = { display: "none" };
    setDisplayBoxType(dispBoxType);

    getBoxCategory();
    getProductCategory();
  }, []);

  const getBoxCategory = () => {
    axios
      .get(environment.dap_url + "boxApi/getAllBoxCategory")
      .then((res) => {
        setboxcategories(res.data);
        console.log(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getProductCategory = () => {
    axios
      .get(environment.dap_url + "productCategory/getAll")
      .then((res) => {
        setproductcategories(res.data);
        console.log(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const displaySuggestion = (index) => {
    // console.log(index)
    const dispSuggestion = [...display_suggestion];
    dispSuggestion[index] = { display: "block", zIndex: "999" };
    setDisplaySuggestion(dispSuggestion);

    // setDisplaySuggestion("block")
  };
  const displayProductSuggestion = (index) => {
    const productSuggestion = [...product_suggestion];
    productSuggestion[index] = { display: "block", zIndex: "999" };
    setProductSuggestion(productSuggestion);

    // setDisplaySuggestion("block")
  };
  const hideProductSuggestion = (index) => {
    const productSuggestion = [...product_suggestion];
    productSuggestion[index] = { display: "none", zIndex: "0" };
    setProductSuggestion(productSuggestion);
  };

  const searchBox = (value) => {
    setboxcategories([]);
    let arr = [];
    if (value == "") getBoxCategory();
    box_categories.filter((category) => {
      // category.includes(value)
      console.log(category.boxCategoryName);
      if (category.boxCategoryName.includes(value)) {
        arr.push(category);
        setboxcategories(arr);
      }
      console.log(arr);
    });
    // console.log(filtered);
  };

  const setDeviceTypeInput = (index, val) => {
    // setDisplaySuggestion("none");
    const dispSuggestion = [...display_suggestion];
    dispSuggestion[index] = { display: "none", zIndex: "-999" };
    setDisplaySuggestion(dispSuggestion);

    const values = [...inputfields];
    values[index]["boxType"] = val;
    console.log(values);
  };

  const setDeviceTypeInputProduct = (index, val, event) => {
    const values = [...inputfields];
    if (val == "DAP BOX") {
      const dispBoxType = [...displayBoxType];
      dispBoxType[index] = { display: "block" };
      setDisplayBoxType(dispBoxType);
      const dispProductSuggestion = [...product_suggestion];
      dispProductSuggestion[index] = { display: "none", zIndex: "-999" };
      setProductSuggestion(dispProductSuggestion);
      document.getElementById("myCheck" + index).checked = true;
      values[index]["isbox"] = true;
    } else {
      const dispProductSuggestion = [...product_suggestion];
      dispProductSuggestion[index] = { display: "block", zIndex: "999" };
      setProductSuggestion(dispProductSuggestion);

      document.getElementById("myCheck" + index).checked = false;
      const dispBoxType = [...displayBoxType];
      values[index]["isbox"] = false;
      // document.getElementById(index+"boxType").value = '';

      dispBoxType[index] = { display: "none" };
      setDisplayBoxType(dispBoxType);
    }
    const dispSuggestion = [...product_suggestion];
    dispSuggestion[index] = { display: "none", zIndex: "-999" };
    setProductSuggestion(dispSuggestion);

    values[index]["deviceType"] = val;

    if (event.target.name == "deviceType") {
      event.target.value = "DAP BOX";
    }

    console.log(values);
  };

  const handleChangeInput = (index, event) => {
    event.persist();
    console.log("hii");
    console.log(event.target.value);
    const myarray = event.target.value.split("|");
    const values = [...inputfields];

    if (event.target.name == "deviceType") {
      if (event.target.value == "DAP BOX") {
        const dispBoxType = [...displayBoxType];
        dispBoxType[index] = { display: "block" };
        setDisplayBoxType(dispBoxType);
        const dispProductSuggestion = [...product_suggestion];
        dispProductSuggestion[index] = { display: "none", zIndex: "-999" };
        setProductSuggestion(dispProductSuggestion);
        values[index]["isbox"] = true;
      } else {
        const dispProductSuggestion = [...product_suggestion];
        dispProductSuggestion[index] = { display: "block", zIndex: "999" };
        setProductSuggestion(dispProductSuggestion);

        document.getElementById("myCheck" + index).checked = false;
        const dispBoxType = [...displayBoxType];
        values[index]["isbox"] = false;
        dispBoxType[index] = { display: "none" };
        setDisplayBoxType(dispBoxType);
      }
    }

    if (event.target.name == "deviceLabel") {
      console.log(event.target.value);

      axios
        .post(environment.dap_url + "dapDevice/checkDuplicate", {
          deviceLabel: event.target.value,
        })
        .then((resp) => {
          console.log(resp);
          if (resp.data.status == true) {
            setDuplicate(false);
          } else {
            setDuplicate(true);
          }
        });
    }

    console.log("---------");

    if (myarray.length == 5) {
      scanqr(index, event, myarray);
    }

    console.log(values);

    if (myarray.length == 5) {
      if (values[index]["deviceLabel"]) {
        console.log(values[index]["deviceLabel"]);

        axios
          .post(environment.dap_url + "dapDevice/checkDuplicate", {
            deviceLabel: myarray[1],
          })
          .then((resp) => {
            console.log(resp);
            if (resp.data.status == true) {
              setDuplicate(false);
            } else {
              setDuplicate(true);
            }
          });
      }
    }

    values[index][event.target.name] = event.target.value;
    setInputFields([...inputfields, values]);
    onScan(index, event);
  };

  const onScan = (index, event) => {
    event.persist();
    if (event.target.value == "DAP BOX" && event.target.name == "deviceType") {
      document.getElementById("myCheck" + index).checked = true;
      const dispBoxType = [...displayBoxType];
      dispBoxType[index] = { display: "block" };
      setDisplayBoxType(dispBoxType);
    } else {
      if (event.target.name == "boxType") {
        // setDeviceTypeInput(index,event.target.value)
        if (event.target.values == "") {
          getBoxCategory();
          console.log("");
        }
        searchBox(event.target.value);
      } else {
        const dispSuggestion = [...display_suggestion];
        dispSuggestion[index] = { display: "none", zIndex: "-999" };
        setDisplaySuggestion(dispSuggestion);
      }
    }
    // console.log(index, event.target.name);
    let qrvalue = event.target.value;
    let qrCodeArray = qrvalue.split("|");
    const values = [...inputfields];
    values[index][event.target.value] = qrCodeArray[0];
    // console.log(values);
    setInputFields(values);
    // setInputFields([
    //   ...inputfields,
    //   {
    //     deviceType: qrCodeArray[1],
    //     deviceLabel:  qrCodeArray[0],
    //     accessToken:  qrCodeArray[2],
    //     deviceVersion:  qrCodeArray[3],
    //     isInstalled: false,
    //   },
    // ]);
    // values[index][event.target.name] = event.target.value;
  };
  const scanqr = async (index, event, myarray) => {
    console.log("QRcodevalue", event.target.value);

    // await axios.post(environment.dap_url+"dapDevice/checkDuplicate",{deviceLabel:myarray[1]}).then(resp=>{
    //   console.log(resp);
    //   if(resp.data.status == true){
    const values = [...inputfields];
    values[index]["deviceLabel"] = myarray[1];
    values[index]["deviceVersion"] = myarray[2];
    values[index]["accessToken"] = myarray[3];
    // values[index]["deviceType"] = myarray[0];
    var el = document.getElementById(index + "deviceType");
    el.value = myarray[0];
    // setInputFields(...inputfields,values)
    //   }else{
    //     MySwal.fire({
    //       title:"Can't add this asset",
    //       text:"This asset is already present in the inventory",
    //       icon:"error"
    //     })
    //     const values = [...inputfields];
    //     values[index]["deviceLabel"] = "";
    //     values[index]["deviceVersion"] = "";
    //     values[index]["AccessToken"] = "";
    //     values[index]["deviceType"] = "";
    //     var el = document.getElementById(index + "deviceType");
    //     el.value = "";
    //   }
    // })

    // values[index]["deviceLabel"] = myarray[1];
    // values[index]["deviceLabel"] = myarray[1];

    // const values = [...inputfields];
    // value[index]['deviceLabel']
  };

  const removeDuplicateDeviceLabels = (inputFields) => {
    const uniqueLabels = [];
    const filteredFields = [];

    inputFields.forEach((field) => {
      if (!uniqueLabels.includes(field.deviceLabel)) {
        uniqueLabels.push(field.deviceLabel);
        filteredFields.push(field);
      }
    });

    return filteredFields;
  };

  const formValidation = (inputfields) => {
    console.log(inputfields);
    let isValid = true;
    inputfields.forEach((element) => {
      if (
        element.deviceName === "" &&
        element.deviceLabel === "" &&
        element.deviceCategory === ""
      ) {
        isValid = false;
      }
    });
    return isValid;
  };
  const submitHandler = (e) => {
    // console.log(inputfields);
    // formValidation(inputfields);
    setLoading(true);
    e.preventDefault();
    // console.log(display_suggestion);
    // console.log("inputfields");
    // console.log(inputfields);

    if (formValidation(inputfields)) {
      const filteredFields = removeDuplicateDeviceLabels(inputfields);
      axios
        .post(
          environment.dap_url + "inventoryApi/addDevicesToInventory",
          filteredFields
        )
        .then((res) => {
          // setLoading(false);
          console.log(res);
          console.log("hello world");
          MySwal.fire({
            title: <p>Device has been successfully Added!</p>,
            type: "success",
          });
          setLabel("");
          setVersion("");
          setAccessToken("");
          setCategory("");
          history.push("/devices");
        })
        .catch((err) => {
          setLoading(false);
          // console.log(err);
          MySwal.fire({
            title: (
              <p>{err?.response?.data?.message || "Device creation failed"}</p>
            ),
            type: "error",
          });
        });
    } else {
      setLoading(false);
      MySwal.fire({
        title: <p>Please enter all values</p>,
        type: "error",
      });
    }
  };
  const handleAddClick = (e) => {
    e.preventDefault();
    // console.log(e.preventDefault);
    setInputFields([
      ...inputfields,
      {
        deviceName: "",
        deviceLabel: "",
        deviceVersion: "",
        deviceCategory: "",
        accessToken: "",
        deviceType: "",
        deviceTypeId: "",
        boxType: "",
        inventoryUserId: JSON.parse(localStorage.getItem("user"))._id,
      },
    ]);
    setDisplayBoxType([...displayBoxType, { display: "none" }]);
    setDisplaySuggestion([
      ...display_suggestion,
      { display: "none", zIndex: "-999" },
    ]);
    setProductSuggestion([
      ...display_suggestion,
      { display: "none", zIndex: "-999" },
    ]);
    console.log("hello");
    // console.log(setInputFields);
    console.log(inputfields);
  };

  const handleRemoveClick = (index, e) => {
    e.preventDefault();
    const dispSuggestion = [...display_suggestion];
    dispSuggestion.splice(index, 1);
    setDisplaySuggestion(dispSuggestion);

    const dispProductSuggestion = [...product_suggestion];
    dispProductSuggestion.splice(index, 1);
    setProductSuggestion(dispProductSuggestion);

    const dispBoxType = [...displayBoxType];
    dispBoxType.splice(index, 1);
    setDisplayBoxType(dispBoxType);

    const values = [...inputfields];
    values.splice(index, 1);
    setInputFields(values);
  };
  return (
    <>
      <div className="container-fluid">
        <NavbarNew />
        <Link to="/devices" className="btn btn-light my-3">
          Go Back
        </Link>
      </div>

      <div className="container">
        <div className="row ">
          <div className="col-md-12 grid-margin stretch-card">
            <div className="card">
              <h1 className="text-center">Add Asset</h1>
              <div>
                <Form onSubmit={submitHandler}>
                  {/* <Form.Group controlId="name">
                    <Form.Label>* Consignee</Form.Label>
                    <CustomListDropDown />
                  </Form.Group>
                  <div className="row">
                    <div className="col-4">
                      <Form.Group controlId="name">
                        <Form.Label>Country</Form.Label>
                        <Select
                          options={countries.map((element) => ({
                            id: element.isoCode,
                            value: element.name,
                            label: element.name,
                          }))}
                          onChange={(e) => selectCountry(e)}
                          // defaultValue={dap_deviceList[0].name}
                          defaultValue="hi there"
                          placeholder="Country"
                        />
                      </Form.Group>
                    </div>
                   

                                    
                  
                    
                  </div> */}

                  <TableContainer>
                    {inputfields.map((inputField, index) => (
                      <div key={index}>
                        <div style={{ display: "inline-flex" }}>
                          <div className="box">
                            <TextField
                              name="deviceType"
                              label="Asset Category"
                              style={{ margin: 5 }}
                              id={index + "deviceType"}
                              value={inputField.deviceType}
                              onFocus={(event) =>
                                displayProductSuggestion(index)
                              }
                              onChange={(event) =>
                                handleChangeInput(index, event)
                              }
                              // onFocusOut={() => hideProductSuggestion(index)}
                              autoComplete="off"
                              onKeyDown={(event) => {
                                if (event.key === "Enter") {
                                  hideProductSuggestion(index);
                                }
                              }}
                              onBlur={() => {
                                setTimeout(() => {
                                  hideProductSuggestion(index);
                                }, 300);
                              }}
                            />

                            <div
                              style={{
                                height: "auto",
                                width: "220px",
                                position: "absolute",
                                backgroundColor: "white",
                                borderRadius: "5px",
                                border: "1px solid #d9d9d9",
                                display: product_suggestion[index].display,
                                zIndex: product_suggestion[index].zIndex,
                              }}
                            >
                              <ul style={{ listStyle: "none" }}>
                                {product_categories?.map((val, key) => {
                                  return (
                                    <li
                                      style={{
                                        padding: "5px",
                                        margin: "2px",
                                        cursor: "pointer",
                                      }}
                                      onClick={(e) => {
                                        setDeviceTypeInputProduct(
                                          index,
                                          val.productCategoryName,
                                          e
                                        );
                                      }}
                                    >
                                      {val.productCategoryName}
                                    </li>
                                  );
                                })}
                              </ul>
                            </div>
                          </div>
                          {/* <Select
                            options={countries.map((element) => ({
                              id: element.isoCode,
                              value: element.name,
                              label: element.name,
                            }))}
                            onChange={(e) => selectCategory(e)}
                            // defaultValue={dap_deviceList[0].name}
                            // defaultValue="hi there"
                            placeholder="Device Category"
                            style={{
                              margin: 5,
                            }}
                          /> */}
                          <TextField
                            name="deviceLabel"
                            label="Asset Label"
                            // variant="filled"
                            style={{
                              margin: 5,
                            }}
                            value={inputField.deviceLabel}
                            onChange={(event) =>
                              handleChangeInput(index, event)
                            }
                          />
                          <TextField
                            name="deviceVersion"
                            label="Asset Version"
                            // variant="filled"git b
                            style={{
                              margin: 5,
                            }}
                            value={inputField.deviceVersion}
                            onChange={(event) =>
                              handleChangeInput(index, event)
                            }
                          />
                          <TextField
                            name="accessToken"
                            label="Access Token"
                            // variant="filled"
                            style={{
                              margin: 5,
                            }}
                            value={inputField.accessToken}
                            onChange={(event) =>
                              handleChangeInput(index, event)
                            }
                          />
                          <div className="box" style={{ width: "auto" }}>
                            <TextField
                              name="boxType"
                              label="Box Category"
                              // variant="filled"
                              style={{
                                margin: 5,
                                display: displayBoxType[index].display,
                              }}
                              id={index + "boxType"}
                              value={inputField.boxType}
                              onChange={(event) =>
                                handleChangeInput(index, event)
                              }
                              onFocus={(e) => displaySuggestion(index)}
                              // onBlur={(e)=>setDisplaySuggestion("none")}
                            />
                            <div
                              style={{
                                height: "auto",
                                width: "220px",
                                position: "absolute",
                                backgroundColor: "white",
                                borderRadius: "5px",
                                border: "1px solid #d9d9d9",
                                display: display_suggestion[index].display,
                                zIndex: display_suggestion[index].zIndex,
                              }}
                            >
                              <ul style={{ listStyle: "none" }}>
                                {box_categories?.map((val, key) => {
                                  return (
                                    <li
                                      style={{
                                        padding: "5px",
                                        margin: "2px",
                                        cursor: "pointer",
                                      }}
                                      onClick={(e) => {
                                        setDeviceTypeInput(
                                          index,
                                          val.boxCategoryName
                                        );
                                      }}
                                    >
                                      {val.boxCategoryName}
                                    </li>
                                  );
                                })}
                              </ul>
                            </div>
                          </div>{" "}
                          <input
                            type="checkbox"
                            id={"myCheck" + index}
                            style={{ marginTop: 24 }}
                          />{" "}
                          Is box?
                        </div>
                        {duplicate ? (
                          <p style={{ marginLeft: "5px", color: "red" }}>
                            Device already present in the inventory
                          </p>
                        ) : (
                          ""
                        )}

                        <div>
                          {index ? (
                            <button
                              className="btn btn-danger btn-sm"
                              style={{
                                margin: 17,
                              }}
                              onClick={(e) => handleRemoveClick(index, e)}
                            >
                              Delete
                            </button>
                          ) : (
                            " "
                          )}
                          <button
                            className="btn btn-primary btn-sm"
                            style={{
                              margin: 17,
                            }}
                            onClick={(e) => handleAddClick(e)}
                          >
                            AddMore
                            {/* <svg
                            // xmlns="http://www.w3.org/2000/svg"
                            width="25"
                            height="25"
                            fill="currentColor"
                            class="bi bi-plus-circle"
                            viewBox="0 0 16 16"
                          >
                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                            <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                          </svg> */}
                          </button>
                        </div>
                      </div>
                    ))}
                  </TableContainer>

                  <div className="col-md-6">
                    <Button
                      type="submit"
                      className="btn btn-block  btn-primary btn-lg font-weight-medium auth-form-btn"
                      disabled={loading || duplicate}
                      style={{ marginLeft: 221 }}
                    >
                      Add Asset
                      {loading && (
                        <i
                          className="fa fa-refresh fa-spin"
                          style={{
                            marginRight: "10px",
                          }}
                        />
                      )}
                      {loading && <span></span>}
                      {!loading && <span></span>}
                    </Button>
                  </div>
                </Form>
              </div>
              <div className="col-lg-3"></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddDeviceSysAdmin;
